/* Social proof that is always on. 2,000+ masks sold is the owner's own
   sales figure (Oct 2026). Rewrites every older count on the page, the
   sticky bar, the cart drawer and the shared header/footer. */
(function(){
var RULES=[
[/\b600\+ sold this season\b/gi,'2,000+ sold'],
[/\b(600|1,000|1000|1\.000)\+ (sold|masks sold|masks|freaks|happy customers|customers|orders|units sold)\b/gi,'2,000+ $2'],
[/\b[Oo]ver (600|1,000|1000) (masks|ski masks|freaks|customers|orders|sold)\b/g,'Over 2,000 $2'],
[/\bOVER (600|1,000|1000) (MASKS|SKI MASKS|FREAKS|CUSTOMERS|ORDERS|SOLD)\b/g,'OVER 2,000 $2'],
[/\b(1,000|1000)\+ SOLD\b/g,'2,000+ SOLD']
];
function rewrite(root){
if(!root)return;
var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null),n;
while((n=w.nextNode())){
var t=n.nodeValue;
if(!t||!/600|1,000|1000|1\.000/.test(t))continue;
var o=t;
for(var i=0;i<RULES.length;i++)t=t.replace(RULES[i][0],RULES[i][1]);
if(t!==o)n.nodeValue=t;
}
}
function run(){rewrite(document.getElementById('if'));rewrite(document.getElementById('if-sticky'));rewrite(document.querySelector('cart-drawer'));rewrite(document.getElementById('if-chrome-head'));rewrite(document.getElementById('if-chrome-foot'));}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
var k=0;var iv=setInterval(function(){run();if(++k>30)clearInterval(iv);},300);
setInterval(run,1500);
})();
